import React from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@swordsweeper/ssi-ui-component-library";
import AuthPageLayout from "@src/components/widgets/AuthPageLayout";
import styles from "./EmailSentPage.module.scss";

interface LocationState {
  email?: string;
}

export default function EmailSentPage(): React.JSX.Element {
  const location = useLocation();
  const email = (location.state as LocationState | null)?.email;

  // The user has no session yet (account is inactive until they click the email
  // link), so we can't bounce them into the app. "Got it!" sends them to the
  // public landing — same exit a logged-out browser tab would take.
  return (
    <AuthPageLayout>
      <div className={styles.card}>
        <div className={styles.copy}>
          <h1 className={styles.title}>Verify Your Email Address</h1>
          <p className={styles.body}>
            We&rsquo;ve sent a verification email
            {email ? (
              <>
                {" "}
                to <strong>{email}</strong>
              </>
            ) : null}
            . Please click the link in the email to verify your email address.
          </p>
        </div>

        <Button
          className={`btn btn-primary btn-md ${styles.confirmButton}`}
          onClick={() => {
            window.location.href = "/";
          }}
          data-testid="email-sent-confirm"
        >
          Got it!
        </Button>
      </div>
    </AuthPageLayout>
  );
}
